import { Layout } from "antd";
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./sidebar/Header";
import { LoggerPage } from "../pages/LoggerPage";
import Sidebar from "./sidebar/Sidebar";
import { MoodlePage } from "../pages/MoodlePage";
import { KoteachVirtualPage } from "../pages/KoteachVirtualPage";

import { AuthComponent, Device } from "../features/VirtualKoteach";

const AppRouter = () => {

  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    // a 401 from $api means the stored token is dead — drop to login
    const onUnauthorized = () => setIsAuth(false);
    window.addEventListener("auth:unauthorized", onUnauthorized);
    return () => window.removeEventListener("auth:unauthorized", onUnauthorized);
  }, []);

  const [collapsed, setCollapsed] = useState<boolean>(
    window.screen.width > 450 ? false : true
  );


  return (
    <div>
      {isAuth ? <Layout style={{ height: "100vh" }}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout>
          <Header collapsed={collapsed} setCollapsed={setCollapsed} />
          <Layout.Content
            style={{
              padding: "16px",
              paddingLeft: window.screen.width > 450 ? "16px" : 0,
              paddingRight: window.screen.width > 450 ? "16px" : 0,
              overflowY: "auto",
            }}
          >
            <Routes>
              <Route path={"/logger"} element={<LoggerPage />} />
              <Route path={"/moodle"} element={<MoodlePage />} />
              <Route path={"/koteachvirtual"} element={<KoteachVirtualPage />} />
            </Routes>
          </Layout.Content>
        </Layout>
      </Layout>
        : <AuthComponent setIsAuth={setIsAuth} />
      }
    </div >
  );
};

export default AppRouter;
